import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next'; 
import './SideMenuBar.css';

function SideMenuBar() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [callCenterPopupOpen, setCallCenterPopupOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [mobileContactOpen, setMobileContactOpen] = useState(false);
  const dropdownRef = useRef(null);
  const { t } = useTranslation();

  // Close dropdown if clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Close popup when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (callCenterPopupOpen && !event.target.closest('.call-center-popup')) {
        setCallCenterPopupOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [callCenterPopupOpen]);

  // Close mobile menu on ESC
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') setMobileMenuOpen(false);
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, []);

  return (
    <div className="side-menu-bar">
      <div className="desktop-stack">
      <div ref={dropdownRef}>
        <button
          className="side-menu-btn register"
          onClick={() => setDropdownOpen((open) => !open)}
          aria-expanded={dropdownOpen}
          aria-haspopup="true"
        >
          <i className="fas fa-user-plus"></i>
          {t('REGISTER')}
        </button>
        {dropdownOpen && (
          <div className="register-dropdown dropdown-menu">
            <Link
              to="/candidate-registration"
              className="dropdown-item nav-link"
              onClick={() => setDropdownOpen(false)}
            >
              {t('header.candidateRegistration')}
            </Link>
            <Link
              to="/employer-registration"
              className="dropdown-item nav-link"
              onClick={() => setDropdownOpen(false)}
            >
              {t('header.employerRegistration')}
            </Link>
          </div>
        )}
      </div>
      <Link to="/login" className="side-menu-btn login">
        <i className="fas fa-sign-in-alt"></i>
        LOGIN
      </Link>
      <button 
        className="side-menu-btn callcenter"
        onClick={() => setCallCenterPopupOpen(true)}
      >
        <i className="fas fa-phone"></i>
        CALL CENTER
      </button>
      
      {/* Call Center Popup */}
      {callCenterPopupOpen && (
        <div className="popup-overlay">
          <div className="call-center-popup">
            <div className="popup-header">
              <h3>Contact Information</h3>
              <button 
                className="close-popup"
                onClick={() => setCallCenterPopupOpen(false)}
              >
                ×
              </button>
            </div>
            <div className="popup-content">
              <div 
                className="contact-item"
                onClick={() => window.open('tel:04024559048')}
                title="Click to call"
              >
                <i className="fas fa-phone"></i>
                <span><strong>Landline:</strong> 04024559048</span>
              </div>
              <div 
                className="contact-item"
                onClick={() => window.open('tel:155326')}
                title="Click to call"
              >
                <i className="fas fa-headset"></i>
                <span><strong>TG Helpline:</strong> 155326</span>
              </div>
              <div 
                className="contact-item"
                onClick={() => window.open('mailto:cdwtghyd@gmail.com')}
                title="Click to send email"
              >
                <i className="fas fa-envelope"></i>
                <span><strong>Email:</strong> cdwtghyd@gmail.com</span>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Mobile hamburger button and overlay menu */}
      </div>

      <button
        className={`mobile-hamburger ${mobileMenuOpen ? 'open' : ''}`}
        aria-label={mobileMenuOpen ? 'Close menu' : 'Open menu'}
        onClick={() => setMobileMenuOpen(v => !v)}
      >
        <span className="hamburger-icon" aria-hidden="true"><span /></span>
      </button>

      {mobileMenuOpen && (
        <div className="mobile-menu-overlay" role="dialog" aria-modal="true">
          <button className="mobile-menu-close" aria-label="Close menu" onClick={() => setMobileMenuOpen(false)}>×</button>
          <nav className="mobile-menu-list">
              <button
                className="mobile-menu-item"
                aria-expanded={mobileContactOpen}
                onClick={() => setMobileContactOpen(s => !s)}
              >
                Registration
              </button>
              {mobileContactOpen && (
                <div className="mobile-submenu">
                  <Link to="/candidate-registration" className="mobile-submenu-item" onClick={() => { setMobileMenuOpen(false); setMobileContactOpen(false); }}>{t('header.candidateRegistration')}</Link>
                  <Link to="/employer-registration" className="mobile-submenu-item" onClick={() => { setMobileMenuOpen(false); setMobileContactOpen(false); }}>{t('header.employerRegistration')}</Link>
                </div>
              )}
            {/* <Link to="/candidate-registration" className="mobile-menu-item" onClick={() => setMobileMenuOpen(false)}>{t('header.candidateRegistration')}</Link>
            <Link to="/employer-registration" className="mobile-menu-item" onClick={() => setMobileMenuOpen(false)}>{t('header.employerRegistration')}</Link> */}
            <Link to="/login" className="mobile-menu-item" onClick={() => setMobileMenuOpen(false)}>Login</Link>
            <button className="mobile-menu-item" onClick={() => { setCallCenterPopupOpen(true); setMobileMenuOpen(false); }}>Call Center</button>
          </nav>
        </div>
      )}
    </div>
  );
}

export default SideMenuBar;
